/**
 * @fileoverview Search module for the Curtis Institute of Music WordPress theme.
 * This module now uses the unified search approach with post type filtering.
 *
 * @module search
 */

// Import the unified search module
import searchUnified from './search-unified';

/**
 * Search module that delegates to the unified search implementation
 * This maintains backward compatibility while using the new unified approach
 */
const search = {
  /**
   * Initializes the search module
   * Delegates to the unified search module
   *
   * @returns {void}
   */
  init() {
    // Use the unified search module
    searchUnified.init();
  }
};

export default search;
